import { AttachedDocumentEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function attachedDocumentOptions(): SelectOption<string>[] {
  return [
    AttachedDocumentEnum.commercial_invoice,
    AttachedDocumentEnum.packing_list,
    AttachedDocumentEnum.shipping_instructions,
    AttachedDocumentEnum.booking_confirmation,
    AttachedDocumentEnum.goods_documents,
    AttachedDocumentEnum.arrival_notice,
    AttachedDocumentEnum.house_airway_bill,
    AttachedDocumentEnum.insurance,
    AttachedDocumentEnum.bill_of_landing,
    AttachedDocumentEnum.other_reference_documents
  ].map((val: AttachedDocumentEnum) => {
    return { value: val, label: i18n.t(`attachedDocument.${val}`).toString() };
  });
}
